import { SplashHero } from '../components/marketing/SplashHero';
import { ValueProps } from '../components/marketing/ValueProps';
import { Footer } from '../components/marketing/Footer';

const heroSubtitle =
  'Open1031 automates the full lifecycle of 1031 exchanges by combining AI-driven workflows, end-to-end security, expert domain logic, and a seamless user experience.';

export default function SplashV2Page() {
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <main className="flex-1">
        <SplashHero subtitle={heroSubtitle} />
        <ValueProps />
      </main>
      <Footer />
    </div>
  );
}
